import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import { ALS_ERLEDIGT_MARKIEREN_LABEL, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue } from 'src/lib/validation/ValidationTypes';
import { checkReadOnlyInUeberarbeitung } from 'src/utils/helper';
import PruefAssistenz from '../../../../../antrag-components/PruefAssistenz';
import ApplicationHeading from '../../../../../application-heading/ApplicationHeading';
import { checkIfPruefAssitenzNeedsToValidate } from '../../../../../application-helper-function/AppHelperfunctions';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

const BeschreibungsDesVorhabensAntragMobilitaetsplaeneUmsetzung: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);
	return (
		<>
			<ApplicationHeading title='Beschreibung des Vorhabens' description={PLATZHALTER_TEXT} />

			<PruefAssistenz
				statusPath={P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Beschreibung_Umsetzung_Pruefstatus.path}
				hinweisPath={
					P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Beschreibung_Umsetzung_Hinweis_Fuer_Den_Antragsteller.path
				}
				ueberarbeitetAmPath={P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Beschreibung_Umsetzung_Ueberarbeitet_Am.path}
				erledigtPath={P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Beschreibung_Umsetzung_Erledigt.path}
				formStruc={formStrucPruefAssistenz()}
			/>

			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={updatedReadOnly} />
		</>
	);
};

export default BeschreibungsDesVorhabensAntragMobilitaetsplaeneUmsetzung;

const formStrucPruefAssistenz = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Beschreibung_Umsetzung_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
	return struc;
};
const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Projektbeschreibung_Mobi_0027393569_zungsprozess_Block_1_Zelle_1,
					validation: [{ validateFunction: ForceTrue }],
				},
				{
					...P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Projektbeschreibung_Mobi_0027393553_zungsprozess_Block_2_Zelle_1,
					validation: [{ validateFunction: ForceTrue }],
				},
				{
					...P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Projektbeschreibung_Mobi_0027393537_zungsprozess_Block_3_Zelle_1,
					validation: [{ validateFunction: ForceTrue }],
				},
				{
					...P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Projektbeschreibung_Mobi_0027393777_zungsprozess_Block_4_Zelle_1,
					validation: [{ validateFunction: ForceTrue }],
				},
				{
					...P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Projektbeschreibung_Mobi_0027393761_zungsprozess_Block_5_Zelle_1,
					validation: [{ validateFunction: ForceTrue }],
				},
				{
					...P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Projektbeschreibung_Mobi_0027393745_zungsprozess_Block_6_Zelle_1,
					validation: [{ validateFunction: ForceTrue }],
				},
				P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Projektbeschreibung_Mobi_0186749246_er_Weiteren_Aufgabengebieten,
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucBeschreibungsDesVorhabensAntragMobilitaetsplaeneUmsetzung = (application: any) => {
	if (
		checkIfPruefAssitenzNeedsToValidate(
			application,
			P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Beschreibung_Umsetzung_Pruefstatus.path,
			P.Projektbeschreibung_Mobilitaetsplaene.schema.attributes.Pruefung_Beschreibung_Umsetzung_Erledigt.path,
		)
	)
		return concat(formStrucPruefAssistenz(), formStruc());
	return concat(formStruc());
};
